import { Pipe, PipeTransform } from '@angular/core';

// Pipe per UPPERCASE
@Pipe({
  name: 'uppercase'
})
export class CustomUppercasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.toUpperCase();
  }
}

// Pipe per lowercase
@Pipe({
  name: 'lowercase'
})
export class CustomLowercasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.toLowerCase();
  }
}

// Pipe per Title Case (prime lettere grandi)
@Pipe({
  name: 'titlecase'
})
export class CustomTitlecasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    
    return value
      .split(' ')
      .map(word => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/stringPipe.ts